// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"2d6c6928","977":"e4f25ea0"}[chunkId] + ".chunk.js";
};